import "./adstypecard.scss";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import React from "react";

interface IAdsTypeCard {
    activate: string
    name:string
    setActivate: React.Dispatch<React.SetStateAction<string>>
    id: number
}

const AdsTypeCard = ({activate,name,setActivate, id}: IAdsTypeCard) => {
    return (
        <div onClick={() => setActivate(`tab${id}`)} className={activate === `tab${id}` ? "Ads-Type-Card activate" : "Ads-Type-Card"}>
            <div>
                <img
                    src={activate === `tab${id}` ? require("../../assets/images/PureLogoLight.svg").default : require("../../assets/images/PureLogoDark.svg").default}
                    alt="" className="img-fluid pe-3"/>
                <span className="Ads-Type-Card-Text">{name}</span>
            </div>
            {activate === `tab${id}` ?
                <KeyboardArrowDownIcon sx={{marginLeft: '1rem', color: activate === `tab${id}` ? "fff" : "#2B2D42"}}/> :
                <KeyboardArrowUpIcon sx={{marginLeft: '1rem', color: activate === `tab${id}` ? "fff" : "#2B2D42"}}/>}
        </div>
    );
}

export default AdsTypeCard;